<template lang="pug">
	.creative--simulate-rules.flex-row.space.wrap(v-if="creative")
		.audio-tracker-button.flex-row.center.align-center.uppercase(@click="show", :class="{ active: totalSimulatedCount > 0}") {{caption}}
		Popup(v-if="initiated", :popupVisible.sync="popupVisible", :width="720", :height="620", :title="$tCaption('Simulate')")
			.creative--simulate-rules--panel.flex-col
				.font-big(v-if="!isLoading && nothingToSimulate") {{$tCaption('Nothing to simulate.')}}
				DxTabPanel(v-if="!isLoading", :dataSource="tabs")
					template(v-slot:title="{ data }")
						span {{data.name}}
					template(v-slot:item="{ data }")
						.tabpanel-item.tb-padding
							.flex-1.flex-col.space(v-if="data.id === 'targets'")
								ListView.full-width.creatives-list-view(
									ref="targetsListView",
									initialView="table",
									:remoteSorting="true",
									:hideViewsSelection="true",
									:getTotal="(r) => r.TotalNumberOfRecords",
									:getItems="(r) => r.Results",
									:getData="getCreativeTargets",
									:columns="columns",
									:filterRow="false",
									:columnAutoWidth="false",
									:columnHidingEnabled="false",
									:height="330"
									:width="300"
									:showColumnHeaders="false",
									:bottomPagerVisible="false",
									:searchVisible="true",
									selectionMode="multiple",
									valueExpr="Oid",
									:selectedRowKeys="selectedTargets && selectedTargets.map(f => f.Oid)",
									@selection="(v, info) => processSelection(info, selectedTargets)"
								)
									template(slot="right-actions")
										DxButton(:icon="targetsAscending ? 'sortuptext' : 'sortdowntext'", @click="toggleTargetsSorting")
							.flex-1.flex-col.space(v-if="data.id === 'rules'")
								ListView.full-width.creatives-list-view(
									ref="rulesListView",
									initialView="table",
									:remoteSorting="true",
									:hideViewsSelection="true",
									:getTotal="(r) => r.TotalNumberOfRecords",
									:getItems="(r) => r.Results",
									:getData="getCreativeRules",
									:columns="columns",
									:filterRow="false",
									:columnAutoWidth="false",
									:columnHidingEnabled="false",
									:height="330"
									:width="300"
									:showColumnHeaders="false",
									:bottomPagerVisible="false",
									:searchVisible="true",
									selectionMode="multiple",
									valueExpr="Oid",
									:selectedRowKeys="selectedRules && selectedRules.map(f => f.Oid)",
									@selection="(v, info) => processSelection(info, selectedRules)"
								)
							.flex-1.flex-col.space-medium(v-if="data.id === 'criteria'")
								.flex-col.space(v-for="item in trackCriteriaParams")
									.font-small.upper.grey {{ item.service.Name }}/{{ item.param.Name }}
									.flex-row.space.algin-center
										SSMLVariativeTextParamEditor.flex-1(:param="item.param", :value.sync="item.value")
										DxButton(v-if="item.value", :hint="$tCaption('Clear', '@actions')", @click="item.value = null", icon="close", stylingMode="text")
				Loader(v-if="isLoading", text="", :fullscreen="true")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Clear', '@actions')", @click="clear")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false")
				DxButton(:text="$tCaption('Simulate', '@actions')", type="default", @click="apply")
</template>
<script>
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import DxButton from 'devextreme-vue/button';	
	import DxTextBox from 'devextreme-vue/text-box';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import Loader from 'app-core/Loader.vue';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import SSMLVariativeTextParamEditor from 'view/insertion/SSMLVariativeTextParamEditor.vue';

	export default {
		translationCategory: 'creative.CreativeSimulateRules',
		name: 'creative--simulate-rules',
		components: { DxDropDownButton, DxButton, DxTextBox, ListView, Popup, Loader, DxTabPanel, SSMLVariativeTextParamEditor },		
		props: ['creative', 'insertions', 'simulatedItems'],
		data() {
			return {	
				columns: [
					{ dataField: 'Name', caption: () => this.$tCaption('Name'), sortIndex: 0, sortOrder: 'asc' },
				],
				selectedTargets: [],
				selectedRules: [],
				popupVisible: false,
				initiated: false,
				hasTargets: false,
				hasRules: false,
				isLoading: 0,
				trackCriteriaParams: [],
				targetsAscending: true
			}
		},
		computed: {
			totalSimulatedCount() {
				let totalCount = (this.simulatedItems?.ruleIds?.length || 0)
					+ (this.simulatedItems?.targetIds?.length || 0)
					+ (this.simulatedItems?.trackCriteriaParams?.length || 0);

				return totalCount;
			},
			caption() {
				return `${this.$tCaption('Simulate')}${(this.totalSimulatedCount > 0 ? ` (${this.totalSimulatedCount})` : '')}`;
			},
			allowedSimulateRules() {
				return this.insertions?.some(f => f.SubInsertions?.some(f => f.eventRuleId || f.EventRule || f?.Targets?.length));
			},
			aggregatedTracks() {
				return this.creative?.JsonConfig?.aggregatedTracks || [];
			},
			tabs() {
				let result = [];

				if (this.hasTargets) {
					result.push({ id: 'targets', name: `${this.$tCaption('Geo-targets')}` })
				}

				if (this.hasRules) {
					result.push({ id: 'rules', name: `${this.$tCaption('Rules')}` })
				}

				if (this.trackCriteriaParams?.length) {
					result.push({ id: 'criteria', name: this.$tCaption('Criteria') })
				}

				return result;
			},
			nothingToSimulate() {
				return !this.tabs.length;
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.creativeSimulateRules = this;
		},
		methods: {
			processSelection(info, arr) {
				this.$nextTick(() => {
					(info?.selected).map(f => {
						if (!arr.find(a => a.Oid === f.Oid)) {
							arr.push(f);
						}
					});

					(info?.deselected).map(f => {
						let idx = arr.findIndex(a => a.Oid === f.Oid);
						if (idx > -1) {
							arr.splice(idx, 1);
						}
					});
				});
			},
			toggleTargetsSorting() {
				this.targetsAscending = !this.targetsAscending;
				this.$refs.targetsListView.pageIndex = 0;
				this.$refs.targetsListView.reload();
			},
			async loadServices() {
				const params = {};

				const getParamsFromCriteria = (criteria) => {
					if (Array.isArray(criteria)) {
						criteria.map(f => {
							if (Array.isArray(f)) {
								getParamsFromCriteria(f)
							} else {
								if (`${f}`.startsWith('service_')) {
									params[f] = {};
								}
							}
						})
					}
				}

				this.aggregatedTracks.filter(f => f?.condition?.criteria).map(f => getParamsFromCriteria(f.condition.criteria));

				const criteriaParams = Object.keys(params).map(f => {
					let split = f.split('service_')[1].split('.');
					return {
						serviceId: split[0],
						paramName: split[1].split('_')[1],
						path: f,
						value: this.simulatedItems?.trackCriteriaParams?.find(p => p?.path === f)?.value
					}
				})

				if (criteriaParams.length) {
					this.isLoading++;
					const services = (await this.$Data.getExternalServices(0, 999).finally(() => this.isLoading--))?.Results;

					criteriaParams.map(p => {
						p.service = services.find(f => f.Oid === p.serviceId);
						p.param = p.service?.JsonDefinition?.Outputs?.find(f => f.Name === p.paramName);
					});
				}

				this.trackCriteriaParams = criteriaParams;
			},
			show() {
				this.popupVisible = false;
				if (!this.initiated) {
					this.initiated = true;
					this.checkHasOptions();
				}
				this.loadServices();
				setImmediate(() => this.popupVisible = true);
			},
			async getCreativeTargets(pageIndex, limit, opts) {
				if (__DEBUG__)
					console.debug('getCreativeTargets', { opts });
				let filterCriteria = `${opts && opts.filter && opts.filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(opts.filter))}` || ''}`;
				if (!filterCriteria && opts?.searchString) {
					filterCriteria = `&filterCriteria=${encodeURIComponent(JSON.stringify([opts?.searchField || 'Target.Name', 'contains', opts?.searchString]))}`;
				}
				let sorting = `&sorting=[{ selector: 'Target.Name', desc: ${!this.targetsAscending} }]`;
				return this.$Data.getExternalApi('Creative/GetCreativeTargetsDx', `creativeId=${this.creative?.Oid}&page=${pageIndex + 1}${filterCriteria}${sorting}`, limit).then(r => {
					this.hasTargets = this.hasTargets || r?.Results?.length;
					return r;
				});
			},
			checkHasOptions() {
				this.hasTargets = false;
				this.hasRules = false;
				this.isLoading++;
				this.getCreativeTargets(0, 1).finally(() => this.isLoading--);
				this.isLoading++;
				this.getCreativeRules(0, 1).finally(() => this.isLoading--);
			},
			async getCreativeRules(pageIndex, limit, opts) {
				return this.$Data.getExternalApi('Creative/GetCreativeRules', `creativeId=${this.creative?.Oid}&page=${Math.max(1, pageIndex + 1)}`, limit).then(r => {
					this.hasRules = this.hasRules || r?.Results?.length;
					return r;
				});
			},
			apply() {
				this.popupVisible = false;
				this.$emit('change', {
					targets: this.selectedTargets,
					rules: this.selectedRules,
					trackCriteriaParams: this.trackCriteriaParams.filter(f => f.value != null)
				}, [...this.selectedTargets.map(f => f.Oid), ...this.selectedRules.map(f => f.Oid)]);
			},
			clear() {
				this.selectedRules = [];
				this.selectedTargets = [];
				this.trackCriteriaParams.map(f => f.value = null);
				if (this.hasTargets) this.$refs.targetsListView.deselectAll();
				if (this.hasRules) this.$refs.rulesListView.deselectAll();
			}
		}
	};
</script>
<style lang="scss">
	.creative--simulate-rules--panel {
		.items-bordered > *:not(:first-child) {
			padding-left: 20px;
			border-left: 1px solid #f4f4f4;
		}
	}
</style>